import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { lazyRetry } from "./RouterUtils";
import { SEMRUSH_HOST } from "./utils/constants";
import { LazyLoader } from "./LazyLoader";

const SignInWrapper = lazy(() => lazyRetry(() => import("./components/SignIn/SignInWrapper")));

const EcomConfirm = lazy(() =>
  lazyRetry(() => import("./components/Workspace/WorkspaceSections/EcomConfirm"))
);
const EcomPaymentConfirm = lazy(() =>
  lazyRetry(() => import("./components/Workspace/WorkspaceSections/EcomPaymentConfirm"))
);
//const Woocommerce = lazy(() => lazyRetry(() => import("./components/StoreComponents/Woocommerce")));
const Ecwid = lazy(() => lazyRetry(() => import("./components/StoreComponents/Ecwid")));
const Wix = lazy(() => lazyRetry(() => import("./components/StoreComponents/Wix")));
const AppRouter = lazy(() => lazyRetry(() => import("./AppRouter")));
const OauthRouter = lazy(() => lazyRetry(() => import("./OauthRouter")));
const Embed = lazy(() => lazyRetry(() => import("./embed/route")));
const LoginSemrush = lazy(() => lazyRetry(() => import("./components/SignIn/LoginSemrush")));
const NotFound = lazy(() => lazyRetry(() => import("./components/NotFound")));
const ForgotPassword = lazy(() =>
  lazyRetry(() => import("./components/ForgotPassword/ForgotPassword"))
);
const ResetPassword = lazy(() =>
  lazyRetry(() => import("./components/ResetPassword/ResetPassword"))
);
const UnsubEmail = lazy(() => lazyRetry(() => import("./components/UnsubEmail/UnsubEmail")));
const SignUp = lazy(() => lazyRetry(() => import("./components/SignUp")));

const ShopifyConfirm = lazy(() => lazyRetry(() => import("./components/Settings/ShopifyConfirm")));
const GptStore = lazy(() => lazyRetry(() => import("./components/gptStore/gptStore")));
const ShareAuth = lazy(() => lazyRetry(() => import("./components/SharePreview/ShareAuth")));

const OnboardingWrapper = lazy(() =>
  lazyRetry(() => import("./components/Onboarding2/OnboardingWrapper"))
);

function NonPublicRouter() {
  const currentURL = new URL(window.location.href);

  const EcomNavigator = () => {
    const url = window.location.pathname;
    const match = url.match(/\/ecom-login\/([^?/]+)/);

    switch (match?.[1]) {
      case "wix":
        return <Wix />;
      // case "woocommerce":
      //   return <Woocommerce />;
      case "ecwid":
        return <Ecwid />;
      default:
        return <Navigate to='/' />;
    }
  };

  return (
    <Routes>
      {/* Auth Routes */}
      <Route
        path='/oauth/*'
        element={
          <LazyLoader>
            <OauthRouter />
          </LazyLoader>
        }
      />
      <Route
        path='/shopify_confirm'
        element={
          <LazyLoader>
            <ShopifyConfirm />
          </LazyLoader>
        }
      />
      <Route
        path='/gpt_store'
        element={
          <LazyLoader>
            <GptStore />
          </LazyLoader>
        }
      />

      <Route
        path='/'
        element={
          currentURL.host === SEMRUSH_HOST ? (
            // for semrush
            <LazyLoader>
              <LoginSemrush />
            </LazyLoader>
          ) : (
            <LazyLoader
              fallback={
                <img
                  src={process.env.PUBLIC_URL + "/predis-logo.svg"}
                  className='animated-element'
                />
              }
            >
              <SignInWrapper />
            </LazyLoader>
          )
        }
      />
      <Route
        path='/ecom-login/:store'
        element={
          <LazyLoader>
            <EcomNavigator />
          </LazyLoader>
        }
      />
      <Route
        path='/ecom_confirm'
        element={
          <LazyLoader>
            <EcomConfirm />
          </LazyLoader>
        }
      />
      <Route
        path='/ecom_payment_confirm'
        element={
          <LazyLoader>
            <EcomPaymentConfirm />
          </LazyLoader>
        }
      />
      <Route
        path='/forgot-password'
        element={
          <LazyLoader>
            <ForgotPassword />
          </LazyLoader>
        }
      />
      <Route
        path='/reset-password'
        element={
          <LazyLoader>
            <ResetPassword />
          </LazyLoader>
        }
      />
      <Route
        path='/email_unsubscribe'
        element={
          <LazyLoader>
            <UnsubEmail />
          </LazyLoader>
        }
      />
      {currentURL.host !== SEMRUSH_HOST && (
        <Route
          path='/signup'
          element={
            <>
              <LazyLoader
                fallback={
                  <img
                    src={process.env.PUBLIC_URL + "/predis-logo.svg"}
                    className='animated-element'
                  />
                }
              >
                <SignUp />
              </LazyLoader>
            </>
          }
        />
      )}
      <Route path='app/*' element={<AppRouter />}></Route>

      <Route
        path='embed/*'
        element={
          <LazyLoader>
            <Embed />
          </LazyLoader>
        }
      ></Route>
      <Route
        path='/igpost/get_post_previews/'
        element={
          <LazyLoader>
            <ShareAuth />
          </LazyLoader>
        }
      />

      <Route
        path='/onboarding'
        element={
          <LazyLoader>
            <OnboardingWrapper />
          </LazyLoader>
        }
      />
      <Route
        path='*'
        element={
          <LazyLoader>
            <NotFound />
          </LazyLoader>
        }
      ></Route>
    </Routes>
  );
}

export default NonPublicRouter;
